import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";

const NewMembers = () => {
  const isPayingMembers = useSelector((state) => state.membership.isPayingMembers);
  const payingMembersNumberTooltip = useSelector(
    (state) => state.membership?.payingMembersNumber?.newMembers?.tooltip
  );
  const {
    tooltip: newMembershipsTooltip,
    newMemberships,
    newMembershipPercentChange,
    url
  } = useSelector((state) => state.membership.newMemberships);
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  let tooltip = isPayingMembers ? payingMembersNumberTooltip : newMembershipsTooltip;
  return (
    <SectionContainer
      title={`New ${isPayingMembers ? "Paying " : ""}Members`}
      toolTip={tooltip}
      toolTipId="newMembersTooltip"
    >
      <NumberDisplay
        value={newMemberships}
        url={url}
        tooltipId="newMembersTooltip"
        toolTipContent={tooltip}
        disableAnimation={isUserQa}
      />
      <PercentChanged
        changeValue={newMembershipPercentChange}
        toolTip="Percentage change from previous month"
        showBorder
      />
    </SectionContainer>
  );
};

export default NewMembers;
